(() => {
  const businessDayTarget = () => {
    const d=new Date(); d.setHours(12,0,0,0);
    let remaining=8;
    while(remaining>0){d.setDate(d.getDate()+1);const day=d.getDay();if(day!==0&&day!==6)remaining--;}
    return d;
  };
  const render=() => {
    const target=businessDayTarget();
    const formatted=new Intl.DateTimeFormat('en-US',{month:'long',day:'numeric',year:'numeric'}).format(target);
    document.querySelectorAll('[data-fl-delivery-date]').forEach(el=>{el.textContent=formatted;});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',render);
  else render();
  document.addEventListener('shopify:section:load',render);
})();